import SidePanelMenu from '@bt-react/components/SidePanelMenu'
import { IconType } from '@bt-react/components/Icon'
import { SidePanelTypes } from '@bt-react/constants'
import { SidePanelMenuItemProps } from '@bt-react/components/SidePanelMenu'
import { connect } from 'react-redux'
import { State } from '../../../dataStore/reducers/reducerType'
import { closeSidePanel, setSelectedMenuItem } from '../../../dataStore/actions/ui/uiActions'

type Dispatch = 'onClick'

const mapStateToProps = (state: State, props: Pick<SidePanelMenuItemProps, 'panel'>): Omit<SidePanelMenuItemProps, Dispatch> => {

  const selected = state.ui.menuItemSelected === props.panel

  return ({
    dataBdd: props.panel,
    title: 'Announcements',
    icon: IconType.iconName.commentAltExclamation,
    panel: props.panel,
    isActive: selected && state.ui.isSidePanelOpen,
    selected,
    notifications: state.messaging.message !== '' ? 1 : 0,
    tooltipText: 'Announcements'
  })
}
const mapDispatchToProps = (dispatch): Pick<SidePanelMenuItemProps, Dispatch> => ({
  onClick: (panel: SidePanelTypes, isActive) => isActive ? dispatch(closeSidePanel()) : dispatch(setSelectedMenuItem(panel))
})

export default connect(mapStateToProps, mapDispatchToProps)(SidePanelMenu.Item)
